import { render } from "./MenuVer.vue?vue&type=template&id=ccc4ac42&scoped=true"
import script from "./MenuVer.vue?vue&type=script&lang=js"
export * from "./MenuVer.vue?vue&type=script&lang=js"

import "./MenuVer.vue?vue&type=style&index=0&id=ccc4ac42&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc4ac42"]])

export default __exports__